module.exports = __webpack_public_path__ + "static/media/ucdavis_logo.290fb6ea.png";